import { downgradeComponent } from '@angular/upgrade/static';
import { KioskFooterComponent } from '../ng2/kiosk/kiosk-footer/kiosk-footer.component';
import { KioskHomeComponent } from '../ng2/kiosk/kiosk-home/kiosk-home.component';
import { KioskAppointmentsComponent } from '../ng2/kiosk/kiosk-appointments/kiosk-appointments.component';
import { KioskInformationsComponent } from '../ng2/kiosk/kiosk-informations/kiosk-informations.component';
import { KioskErrorComponent } from '../ng2/kiosk/kiosk-error/kiosk-error.component';

const dependencies = ['main'];

const kiosk = angular.module('kiosk', dependencies);

const autoload = require.context('.', true, /\.(html|json|woff|woff2|ttf|eot|svg|gif|png|jpg)$/);
const object = autoload.keys();
object.forEach((name) => {
  autoload(name);
});

kiosk
  .config(require('./config/routes.js'))
  .directive('kioskFooter', downgradeComponent({
    component: KioskFooterComponent,
    inputs: [],
    outputs: [],
  }))
  .directive('kioskHome', downgradeComponent({
    component: KioskHomeComponent,
    inputs: [],
    outputs: [],
  }))
  .directive('kioskAppointments', downgradeComponent({
    component: KioskAppointmentsComponent,
    inputs: [],
    outputs: [],
  }))
  .directive('kioskInformations', downgradeComponent({
    component: KioskInformationsComponent,
    inputs: [],
    outputs: [],
  }))
  .directive('kioskError', downgradeComponent({
    component: KioskErrorComponent,
    inputs: [],
    outputs: [],
  }))
  .run(['$translate', '$translatePartialLoader', ($translate, $translatePartialLoader) => {
    $translatePartialLoader.addPart('kiosk');
    return $translate.refresh();
  },
  ]);

module.exports = kiosk;



// WEBPACK FOOTER //
// ./kiosk/kiosk.js